import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { NlpAgent } from './components';

const routes = () => (
  <PrivateRoute
    exact
    path="/nlp/agent"
    component={NlpAgent}
  />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/NlpAgent/routes.js